import { getLocationParam } from 'utils/url-utils';
import { PRESAVE_PARAMS } from 'consts/flow-constants';

import {
  getAndPresaveAccountProps,
  getAndPresaveCreateLoginAndPassProps,
  getAndPresavePhoneProps,
  getAndPresaveSecureAnswersProps,
  getSignInPresavedProps,
} from 'app/props/presaved-props';

import {
  BankAccountErrors,
  LoginErrors,
  CreatePasswordErrors,
  KcContext,
  KcLoginContext,
  KcContextOTPExtenstion,
  KcContextQuestionsExtension,
  KcContextScratchExtenstion,
  KcRegisterContext,
  KcResetPasswordContext,
  SignInErrors,
  OtpErrors,
  ScratchErrors,
  SecureAnswerErrors,
  CaptchaErrors,
} from 'types';

import { errorExistsIn } from 'utils/error-utils';

import { type CreateLoginAndPasswordFormProps } from 'pages/registration-step-3-page/components/create-login-and-password-form';

export function getSignInPropsFromKcContext(kcContext: KcLoginContext) {
  const error = kcContext?.message?.summary;

  return {
    error: error as SignInErrors,
    selectedCredential: kcContext.auth.selectedCredential || '',
    captchaModal: !!kcContext.captcha || !!errorExistsIn(error, CaptchaErrors),
    captchaData: kcContext.captcha,
    fogotPasswordModal: kcContext.captcha_success,
    ...getSignInPresavedProps(),
  };
}

export function getPhoneActivatePropsFromKcContext(kcContext: KcContext & KcContextOTPExtenstion) {
  return {
    ...getAndPresavePhoneProps(kcContext),
  };
}

export function getOtpPropsFromKcContext(kcContext: KcContext & KcContextOTPExtenstion) {
  return {
    error: kcContext?.message?.summary as OtpErrors,
    resendCodePosibleAfterSeconds: kcContext.sms_blocking_time,

    ...getAndPresavePhoneProps(kcContext),
  };
}

export function getScratchPropsFromKcContext(kcContext: KcContext & KcContextScratchExtenstion) {
  return {
    card: kcContext.tan_set_id,
    codeNumber: kcContext.tan_number,
    availableKeysCount: parseInt(kcContext.tan_key_count),
    error: kcContext?.message?.summary as ScratchErrors,
  };
}

export function getBankAccountPropsFromKcContext(kcContext: KcContext) {
  return {
    number: getLocationParam(PRESAVE_PARAMS.ACCOUNT_NUMBER) || '',
    error: kcContext?.message?.summary as BankAccountErrors,

    ...getAndPresaveAccountProps(),
  };
}

export function getQuestionsPropsFromKcContext(kcContext: KcContextQuestionsExtension) {
  return {
    questions: {
      en: kcContext.secret_question_en || [],
      ru: kcContext.secret_question_ru || [],
    },
  };
}

export function getCreateLoginAndPassPropsFromKcContext(kcContext: KcRegisterContext): Partial<CreateLoginAndPasswordFormProps> {
  return {
    username: kcContext?.login?.username,
    password: kcContext?.login?.password,
    error: kcContext?.message?.summary as LoginErrors,
    phoneSwitcherOn: kcContext.register?.formData.mobile_auth_consent !== 'false',

    ...getAndPresaveCreateLoginAndPassProps(kcContext),
  };
}

export function getSecureAnswersPropsFromKcContext(kcContext: KcResetPasswordContext) {
  return {
    action: kcContext.url?.loginAction,
    error: kcContext?.message?.summary as SecureAnswerErrors,

    ...getQuestionsPropsFromKcContext(kcContext),
    ...getAndPresaveSecureAnswersProps(kcContext),
  };
}

export function getRecreatePasswordPropsFromKcContext(kcContext: KcResetPasswordContext) {
  return {
    error: kcContext?.message?.summary as CreatePasswordErrors,
  };
}
